export function injectGtm (id: string): void {
  // Inject GTM <script> tag into head
  const gtmScript = document.createElement('script')
  gtmScript.async = true
  gtmScript.src = `${process.env.VUE_APP_INSIGHTS_URI}/gtm.js?id=${id}`
  document.head.append(gtmScript)
}
